module.exports = __webpack_public_path__ + "media/images/pc/stores/kyoto/kyoto_concept_03-fe0cfe4d7a800ca8b199b1339a0c2e65.jpg";